import { render, staticRenderFns } from "./InvestismentGroup.vue?vue&type=template&id=a11d26ea&scoped=true"
import script from "./InvestismentGroup.vue?vue&type=script&lang=js"
export * from "./InvestismentGroup.vue?vue&type=script&lang=js"
import style0 from "./InvestismentGroup.vue?vue&type=style&index=0&id=a11d26ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11d26ea",
  null
  
)

export default component.exports